import { motion } from "framer-motion";
import { IMAGES } from "./site";

const CARDS = [
    {
        src: IMAGES.reading,
        alt: "Young learner reading a book",
        title: "Confident Readers",
        text: "Build reading fluency, understand texts and discover new vocabulary.",
    },
    {
        src: IMAGES.writing,
        alt: "Young learner practising writing on paper",
        title: "Creative Writers",
        text: "Practise sentences, paragraphs and imaginative writing step by step.",
    },
    {
        src: IMAGES.online,
        alt: "Young learner taking part in an online lesson on a laptop",
        title: "Online Learning",
        text: "Learn from home with focused activities designed around learning goals.",
    },
];

export const Gallery = () => (
    <section className="mx-auto max-w-7xl px-6 py-20 lg:py-28" data-testid="gallery-section">
        <motion.div
            className="max-w-2xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
        >
            <p className="text-xs font-bold tracking-widest text-sun uppercase">Learning in action</p>
            <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                Every lesson is a chance to shine
            </h2>
            <p className="mt-4 text-base text-mist sm:text-lg">
                From reading and writing to online learning, we help young learners practise important English
                skills in a welcoming environment.
            </p>
        </motion.div>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
            {CARDS.map((card, i) => (
                <motion.figure
                    key={card.title}
                    data-testid={`gallery-card-${i + 1}`}
                    className="group overflow-hidden rounded-3xl border border-ground-line/70 bg-ground-soft/50 transition-all duration-300 hover:-translate-y-1 hover:border-sun/50 hover:shadow-xl hover:shadow-black/30"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.55, delay: i * 0.12 }}
                >
                    <div className="overflow-hidden">
                        <img
                            src={card.src}
                            alt={card.alt}
                            loading="lazy"
                            className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                    </div>
                    <figcaption className="p-6">
                        <h3 className="font-heading text-lg font-bold text-sun">{card.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-mist">{card.text}</p>
                    </figcaption>
                </motion.figure>
            ))}
        </div>
        <p className="mt-6 text-xs text-mist/70">
            Photos are sample visuals of young learners, not photographs of actual YNova Education students.
        </p>
    </section>
);
